import { useEffect, useRef, useState } from 'react'
import { BoardListItem, GetBoardData, getHeaderTitle } from '../boardItem'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAxios } from '@/context/axiosContext'
import { InquiryBoardList } from './inquiryBoardList'
import MenuInfo from '@/pages/menu/menuInfo'
import { MenuHeader } from '@/pages/menu/menuHeader'
import { SEO } from '@/components/seo/seo'
import { useResponsive } from '@/hooks/useResponsive'

const InquiryBoard: React.FC = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const [page, setPage] = useState(location.state?.page || 1)
  const [listData, setListData] = useState<BoardListItem[]>([])
  const [totalCount, setTotalCount] = useState(0) //페이지 count
  const [srchData, setSrchData] = useState({
    srchOpt: '01',
    srchStr: '',
  })
  const menuInfoRef = useRef<HTMLDivElement | null>(null)
  const [hasMenuInfo, setHasMenuInfo] = useState<boolean>(true)
  useEffect(() => {
    // location.state가 있을 경우, 즉 뒤로가기 등에서 복귀한 경우
    if (location.state) {
      setPage(location.state.page || 1)
      setSrchData({
        srchOpt: location.state.srchOpt || '01',
        srchStr: location.state.srchStr || '',
      })
    } else {
      // 새로고침이거나 직접 URL 입력한 경우는 초기화
      setPage(1)
      setSrchData({
        srchOpt: '01',
        srchStr: '',
      })

      navigate('/inquiry', { replace: true })
    }
  }, [])

  useEffect(() => {
    getInquiryBoardList(page)
  }, [page])

  const getInquiryBoardList = async (pageParam: number) => {
    try {
      const data: GetBoardData = {
        srchOpt: srchData.srchOpt,
        srchStr: srchData.srchStr,
        page: pageParam,
      }

      const response = await axios.get(`/inquiry/list`, {
        headers: { 'Cache-Control': 'no-cache' },
        params: { ...data },
      })

      const { boardList, pageCnt } = response.data.data

      if (Array.isArray(boardList)) {
        setListData(boardList)
      }
      setTotalCount(pageCnt)
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  return (
    <>
      <SEO
        title="문의"
        //description="꿀프에서 골프 관련 서비스를 확인하세요."
        canonicalUrl="https://ggoollff.co.kr/inquiry"
      />
      <div style={{ padding: isMobile ? '0 15px' : '0' }}>
        <MenuHeader
          pathName={location.pathname}
          showWriteButton={true}
          menuInfoRef={menuInfoRef}
          loginRequired={false}
          iconActive={hasMenuInfo}
        />
      </div>
      <InquiryBoardList
        srchData={srchData}
        setSrchData={setSrchData}
        setPage={setPage}
        boardList={listData}
        pageCnt={totalCount}
        getBoardList={getInquiryBoardList}
        boardSrchData={{
          srchOpt: srchData.srchOpt,
          srchStr: srchData.srchStr,
          page: page,
        }}
      />
      <div ref={menuInfoRef}>
        <MenuInfo menuPath={location.pathname} onDataCheck={setHasMenuInfo} />
      </div>
    </>
  )
}

export default InquiryBoard
